/*jshint esversion: 6 */
/**
 * Created by zato93 on 10/12/17.
 */
import Vue from 'vue';



//export default VueGearboxApi;







/*document.body.addEventListener('touchmove', function(e) {
    var a = e.target;
    let found = false;
    while (a) {
        if(a.classList&&a.classList.value.indexOf('scrollman') != -1){
            found = true;
        }
        a = a.parentNode;
    }
    if(!found){
        console.log('prevent scroll');
        e.preventDefault();
    }


}, false);
*/



let VueGearboxApi = {
    install(Vue, options) {

        let error = (res) => {
            console.error("AJAX ERROR", res.body.error);
        };

        ['post', 'put', 'patch'].forEach((method) => {
            Vue.http['i' + method] = (url, body, options) => {
                return new Promise((resolve, reject) => {
                    Vue.http[method](url, body, options).then((res) => {
                        resolve(res.body);
                    }, (res) => {
                        //reject("NETWORK_ERROR");
                        reject(res.body.error);
                        alert(res.body.error.description || res.body.error.message);
                        error(res);
                    });
                });
            };
        });
        ["get", "head", "delete", "jsonp"].forEach((method) => {
            Vue.http['i' + method] = (url, options) => {
                return new Promise((resolve, reject) => {
                    Vue.http[method](url, options).then((res) => {
                        resolve(res.body);
                    }, (res) => {
                        reject(res.body.error);
                        if (res.body.error) {
                            alert(res.body.error.description || res.body.error.message);
                        }
                        error(res);
                    });
                });
            };
        });

    }
};
export default VueGearboxApi;

